import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  userData: {},
  timePreference24Hour: 13,
  timePreference: 11
}

const getters = {
  userData: state => state.userData,
  dashboardPreferencesLoading: state => state.dashboardPreferencesLoading,
  dashboardPreferencesError: state => state.dashboardPreferencesError,
  dashboardPreferences: state => state.dashboardPreferences,
  timePreference24Hour: state => state.timePreference24Hour,
  timePreference: state => state.timePreference
}

const mutations = {
  [types.GET_USER_DATA_REQUEST] (state) {
    state.dashboardPreferencesLoading = true
    state.dashboardPreferencesError = {}
    state.userData = {}
  },
  [types.GET_USER_DATA_FAILURE] (state, dashboardPreferencesError) {
    state.dashboardPreferencesLoading = false
    state.dashboardPreferencesError = dashboardPreferencesError
    state.userData = {}
  },
  [types.GET_USER_DATA_SUCCESS] (state, userData) {
    state.dashboardPreferencesLoading = false
    state.dashboardPreferencesError = {}
    state.userData = userData
  },
  [types.ALTER_USER_24_HOUR_TIME_PREFERENCE] (state, timePreference24Hour) {
    state.timePreference24Hour = timePreference24Hour
  },
  [types.ALTER_USER_TIME_PREFERENCE] (state, timePreference) {
    state.timePreference = timePreference
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
